import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import { StatusBar, Style } from "@capacitor/status-bar";

// Native-only polish so the app doesn't feel like a bare WebView wrapper:
// status bar matching the app's header color, and Android's hardware back
// button navigating app history instead of doing nothing/exiting
// immediately. (Keyboard resize-on-open is handled declaratively via
// android:windowSoftInputMode="adjustResize" in AndroidManifest.xml —
// @capacitor/keyboard's setResizeMode() is an intentional no-op on Android.)
export function setupNativeApp() {
  if (!Capacitor.isNativePlatform()) return;

  StatusBar.setBackgroundColor({ color: "#2f2f2f" });
  StatusBar.setStyle({ style: Style.Dark });

  App.addListener("backButton", ({ canGoBack }) => {
    if (canGoBack) {
      window.history.back();
    } else {
      App.exitApp();
    }
  });

  // App Links (invite/join/reset/confirm emails) land here instead of a
  // browser once Android verifies assetlinks.json — the OS hands us the full
  // URL, and since it's the same origin the app already runs on, navigating
  // to it in place is enough for the router to pick up the route.
  App.addListener("appUrlOpen", ({ url }) => {
    window.location.href = url;
  });
}
